import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BadgeIssue, DigitalBadge } from '../models/digital-badge';

@Injectable({
  providedIn: 'root'
})
export class DigitalBadgeService {

  endpoint: string;
  constructor(private http: HttpClient) {
    this.endpoint = `${environment.apiUrl}/awards`;
  }

  public getForEvent(evenyName: string): Observable<DigitalBadge[]> {
    const url = `${this.endpoint}/credly?term=${evenyName}`;
    const headers = new HttpHeaders().set('Authorization', sessionStorage.getItem('token'));
    return this.http.get<DigitalBadge[]>(url, { headers});
  }

  public issueBadge(data: BadgeIssue): Observable<any> {
    const url = `${this.endpoint}/credly/issue`;
    const headers = new HttpHeaders().set('Authorization', sessionStorage.getItem('token'));
    return this.http.post(url, data, { headers });
  }

  public issueBadgeBulk(data: BadgeIssue[]): Observable<any> {
    const url = `${this.endpoint}/credly/issueBulk`;
    const headers = new HttpHeaders().set('Authorization', sessionStorage.getItem('token'));
    return this.http.post(url, data, { headers });
  }
}
